// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'goals'

/**
 * Goal Model Interface (auto-generated from Drizzle schema)
 */
export interface GoalModel {
  id: string
  orgId: string
  workspaceId?: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  name?: string
  title: string
  description?: string
  status: string
  priority: string
  category: string
  progressMode?: string
  currentProgress?: number
  completed: boolean
  dueDate?: string
  targetDate?: string
  parentGoalId: string
  metrics?: unknown[]
  archived: boolean
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "name": {
          "type": "string",
          "maxLength": 500
      },
      "title": {
          "type": "string",
          "maxLength": 500
      },
      "description": {
          "type": "string",
          "maxLength": 100000
      },
      "status": {
          "type": "string",
          "maxLength": 50
      },
      "priority": {
          "type": "string",
          "maxLength": 50
      },
      "category": {
          "type": "string",
          "maxLength": 200
      },
      "progressMode": {
          "type": "string",
          "maxLength": 200
      },
      "currentProgress": {
          "type": "number",
          "minimum": 0,
          "maximum": 100,
          "multipleOf": 1
      },
      "completed": {
          "type": "boolean"
      },
      "dueDate": {
          "type": "string",
          "maxLength": 200
      },
      "targetDate": {
          "type": "string",
          "maxLength": 200
      },
      "parentGoalId": {
          "type": "string",
          "maxLength": 100
      },
      "metrics": {
          "type": "array",
          "items": {}
      },
      "archived": {
          "type": "boolean"
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "title",
      "status",
      "priority",
      "completed",
      "archived",
      "category",
      "parentGoalId"
  ],
  indexes: [
      [
          "orgId",
          "status",
          "createdAt"
      ],
      [
          "orgId",
          "category"
      ],
      [
          "orgId",
          "parentGoalId"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
